var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    "hash": "9158963",
    "raw": "v3.21.1",
    "semverString": "3.21.1"
  };
  //# sourceMappingURL=version.js.map
  return exports;
}